import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
// Tokens de color de la marca (tema claro/oscuro). Va después de Bootstrap
// para que los valores --sn-* manden en cualquier empate de especificidad.
import './styles/temas.css';

const container = document.getElementById('root');
if (!container) throw new Error('No se encontró el contenedor #root');

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
